import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import styled from "styled-components";

const BackgroundWrapper = styled.div`
  background-color: #f0f2f5;
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
`;

const ContentWrapper = styled.div`
  max-width: 600px;
  width: 100%;
  padding: 40px;
  background: #ffffff;
  border-radius: 12px;
  color: #000;
  text-align: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const Title = styled.h1`
  font-family: Pretendard, sans-serif;
  font-size: 36px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #f44336;
`;

const Description = styled.p`
  font-family: Pretendard, sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 27px;
  opacity: 0.8;
  margin-bottom: 30px;
`;

const Button = styled.button`
  padding: 12.5px 20px;
  border-radius: 8px;
  background-color: #ff3e61;
  font-family: Pretendard, sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s;
  &:hover {
    background-color: #ff2545;
  }
`;

const IconWrapper = styled.div`
  margin-bottom: 20px;
`;

const ErrorDetails = styled.div`
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 30px;
  text-align: left;
`;

const ErrorDetailItem = styled.p`
  font-family: Pretendard, sans-serif;
  font-size: 16px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  word-break: break-word;
`;

export function FailPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const errorCode = searchParams.get("code");
  const errorMessage = searchParams.get("message") || "결제 처리 중 오류가 발생했습니다.";

  // 특정 에러 코드에 대한 추가 안내 메시지
  const getErrorGuidance = (code) => {
    if (code === "REJECT_ACCOUNT_PAYMENT") {
      return "계좌 잔액이 부족합니다. 계좌 잔액을 확인한 후 다시 시도해 주세요.";
    }
    return null;
  };

  const errorGuidance = getErrorGuidance(errorCode);

  const ErrorIcon = () => (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="32" cy="32" r="32" fill="#f44336" />
      <path
        d="M20 20L44 44M44 20L20 44"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return (
    <BackgroundWrapper>
      <ContentWrapper>
        <IconWrapper>
          <ErrorIcon />
        </IconWrapper>
        <Title>결제에 실패했습니다</Title>
        <Description>
          결제 처리 중 문제가 발생했습니다. 아래 정보를 확인하시고
          다시 시도해 주세요. 문제가 계속되면 고객센터로 문의해 주세요.
        </Description>
        <ErrorDetails>
          {errorCode && (
            <ErrorDetailItem>
              <strong>에러 코드:</strong> <span>{errorCode}</span>
            </ErrorDetailItem>
          )}
          <ErrorDetailItem>
            <strong>실패 사유:</strong> <span>{errorMessage}</span>
          </ErrorDetailItem>
          {errorGuidance && (
            <ErrorDetailItem style={{ marginTop: "15px", paddingTop: "15px", borderTop: "1px solid #e0e0e0" }}>
              <strong>안내:</strong> <span>{errorGuidance}</span>
            </ErrorDetailItem>
          )}
        </ErrorDetails>
        <Button onClick={() => navigate("/plans")}>
          결제 페이지로 돌아가기
        </Button>
      </ContentWrapper>
    </BackgroundWrapper>
  );
}